import {$} from '../third-party-imports';
import {fullAddressRoundRobinApi}from './fullAddressRoundRobinApi';
import {disPlayListOfServices} from '../services/disPlayListOfServices';
export function servicesListDisplayModal(postalCode:any){
    fullAddressRoundRobinApi(postalCode,false,()=>{
        $('.scheduler-modal .modal-content').addClass('banner-wizard');
        disPlayListOfServices(postalCode);
    },'');
}